export default {"src":"/_next/static/media/assistant-nurse-with-small-green-text-box.1560ba2b.svg","height":364,"width":260};